export const productStyles = {
  grid: {
    mx: {
      laptop: "0.938rem",
    },
  },
  card: {
    my: {
      mobile: "1.25rem",
    },
    borderRadius: "0.938rem",
    boxShadow: "none",
    height: {
      tablet: "19.375rem",
      laptop: "29.875rem",
    },
    maxWidth: {
      tablet: "50rem",
      laptop: "21.875rem",
      desktop: "21.3rem",
    },
  },
  container: {
    display: {
      tablet: "flex",
    },
    flexDirection: {
      tablet: "row",
      laptop: "column",
    },
    borderRadius: {
      laptop: "0.938rem",
    },
    cursor: "pointer",
    transition: "background-color 0.3s ease-in-out",
  },
  cardMedia: {
    maxWidth: {
      tablet: "21.188rem",
      laptop: "unset",
    },
  },
  cardContent: {
    my: "auto",
    mx: {
      laptop: "auto",
    },
    padding: {
      mobile: "2rem 1.875rem",
    },
    textAlign: "center",
    borderRaidus: {
      laptop: "0.938rem",
    },
  },
  title: {
    textTransform: "uppercase",
    transition: "color 0.3s ease-in-out",
    mb: {
      mobile: "1rem",
    },
  },
  description: {
    transition: "color 0.3s ease-in-out",
    width: {
      laptop: "15.625rem",
    },
  },
};
